import { useState } from "react";
import DocumentStaffPdf from "./document-staff-pdf";
import Loading from "../../control-components/loader/loader";
import { showError } from "src/util/utility";
import { API_ENDPOINTS } from "src/services/api-endpoints";
import { customAxios } from "src/services/useExPressApi";
import NoteneticButton from "src/control-components/button";

const StaffServiceReport = ({ postBodyObject }) => {
    const [reportData, setReportData] = useState([]);
    const [isPrintPDF, setIsPrintPDF] = useState(false);
    const [loading, setLoading] = useState(false);
    const { startDate, endDate } = postBodyObject;
    const { utcDateCreated, setUtcDateCreated } = postBodyObject;
    function handleStaffServiceReport() {
        setLoading(true);
        customAxios.post(API_ENDPOINTS.GET_STAFF_SERVICE_REPORT, postBodyObject)
            .then((result: any) => {
                setReportData(result?.resultData);
                setIsPrintPDF(true);
            })
            .catch((error) => {
                showError("Could not complete the request!", "Staff Service Report");

            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 0);
            });
    }

    return (
        <>
            {loading && (
                <div>
                    <Loading />
                </div>
            )}
           
            <NoteneticButton
                iconName="fa-solid fa-file-pdf"
                text={'Staff Service Report'}
                onClick={handleStaffServiceReport}
                preset="bordered"
            ></NoteneticButton>
            {(isPrintPDF && reportData) && (
                <DocumentStaffPdf
                    reportData={reportData}
                    setIsPrintPDF={setIsPrintPDF}
                    isPrintPDF={isPrintPDF}
                    startDate={startDate}
                    endDate={endDate}
                    utcDateCreated={utcDateCreated}


                />
            )}
        </>
    );
};

export default StaffServiceReport;
